// extracted by mini-css-extract-plugin
export default {"wrap":"ServerError_wrap__-YklU","errorMessage":"ServerError_errorMessage__fbhUF"};